<script lang="ts">
	import StrapiContent from './StrapiContent.svelte';

	interface Props {
		uid: string;
	}

	let { uid }: Props = $props();

	async function getTextTemplate(uid: string) {
		const textTemplates = await fetch(`/api/text-templates/${uid}`).then(
			(res) => res.json() as unknown as TextTemplate[]
		);

		return textTemplates[0];
	}
</script>

{#await getTextTemplate(uid) then textTemplate}
	{#if textTemplate?.content}
		<StrapiContent content={textTemplate.content} />
	{/if}
{/await}
